export default {
  onefid: "ONEFID",
  telephone: "+ 49 221 95793412",
  "how to use": "ANLEITUNG",
  "customer support": "KUNDEN SUPPORT",
  catalog: "Katalog",
  start: "START",
  back: "ZURÜCK",
  goBack: "ZURÜCK",
  next: "WEITER",
  "new scan": "NEUER SCAN",
  home: "HOME",
  "no scanner found": "Keine 3D Scanner gefunden.",
  "detect scanner message": "Suche nach 3D Scannern",
  yes: "JA",
  no: "NEIN",
  measurements: "Messungen",
  analysis: "Analyse",
  more: "Mehr",
  "new user": "Neuer Benutzer",
  "new scan modal logged in user": "Dieser Benutzer ist angemeldet\nWillst Du einen neuen Scan anlegen\noder Dich ausloggen?",
  "new scan modal not logged in user": '"NEUR SCAN" wurde gewählt\ndies überschreibt die momentanen Ergebnisse.\nWie willst du fortfahren?',
  "save result": "Ergnisse speichern",
  weight: "Gewicht",
  activity: "Aktivität",
  searchPlaceHolder: "Was suchst Du?",
  loadProductMessage: "Bitte warten Sie während Ihr individueller Produktkatalog geladen wird. Dies kann einen Moment dauern...",
  noProductFoundMessage: "Sorry, leider konnten wir für Deine Größe keine passenden Produkte finden!",
  noSearchProductFoundMessage: "Sorry, für diese Scuhe wurden leider keine Produkte gefunden!",
  resetFilter: "Filter zurücksetzen",
  loadMoreProducts: "Lade mehr Produkte!",
  "make new search": "Neue Suche",
  "In stock": "Auf Lager",
  projectedStock: "Erwarteter Bestand",
  "out of stock": "nicht vorrättig",
  SAVE: "Speichern",
  FEEDBACK: "FEEDBACK",
  "order now": "JETZT BESTELLEN",
  price: "Preis",
  noInternet: "Wir konnten keine Internetverbindung finden. Bitte überprüfen",
  moreDetails: "mehr Details",
  recommendedForYou: "EMPFOHLEN FÜR  DICH",
  addItem: "Einlage hinzufügen",
  mainScreen: "Main Screen",
  createInsole: "Insole Erstellen",
  insoleCreation: "Die Erstellung der Einlegesohle ist in Arbeit",
  shoeSize: "Größe",
  insoleType: "Einlagentyp",
  recommendedInsole: "Empfohlene Einlegesohle: ",
  sport: "Sport",
  everyday: "Alltag",
  chooseCustomer: "FIRMENKUNDE WÄHLEN",
  createEvent: "EVENT ANLEGEN",
  createButton: "ANLEGEN",
  chooseButton: "WÄHLEN",
  adjustSize: "GRÖßE ANPASSEN",
  comments: "Kommentare",
  createProcess: "Vorgang anlegen",
  "legLengthCompensation1,5cm": "BEINLÄNGENAUSGLEICH BIS 1,5 CM",
  legLengthCompensation3cm: "BEINLÄNGENAUSGLEICH BIS 3 CM",
  inOutEdgeElevation: "INNEN-/AUßENRANDERHÖUNG ",
  corkWedge: "KORKKEIL",
  haglundFerse: "HAGLUNDFERSE",
  wheelingSole: "ABROLLSOHLE",
  butterflyRoll: "SCHMETTERLINGSROLLE",
  orthoOrderSuccessMessage: "Wir haben Ihre orthopädischen\n Schuh- und Einlagenanpassungen erfolgreich gespeichert",
  orthopedicInsole: "ORTHOPÄDISCHE EINLAGE",
  changeSizeButton: "Größe auswählen",
  shoeAdaptionsModalTitle: "Zurichtungen",
  listOfSizes: "Liste der Größen",
  orthoOrder: "Ortho Bestellung",
  shoeFitting: "SCHUHZURICHTUNG",
  fullCatalog: "ELTEN GESAMTKATALOG",
  accessoriesCatalogTitle: "Zubehör",
  repeatScanButton: "Scan wiederholen",
  items: "Artikel",
  removeButton: "entfernen",
  checkoutButton: "Abschicken",
  cartIsEmpty: "Warenkorb ist leer",
  orthoInsolePopupText: "Pro Bestellung ist nur eine orthopädische Einlage zulässig.",
  closeButton: "schließen",
  customInsole: "Individuelle Einlegesohle",
  itemsInCartWarning: "Es sind noch Artikel im Warenkorb der nicht abgeschlossen ist.\nTrotzdem fortfahren?",
  cartButton: "Warenkorb",
  white: "Weiß",
  black: "Schwarz",
  selectLanguage: "Sprache auswählen",
  sizeRecommendation: "Größenempfehlung",
  printButton: "FERTIGSTELLEN UND DRUCKEN",

  newScan: {
    headlines: {
      gender: "Geschlecht",
      mode: "Modus",
      confirmation: "Bestätigen",
    },
    origin: "HERKUNFTSREGION",
    "north-america": "Nord Amerika",
    "south-america": "Süd Amerika",
    europe: "Europa",
    africa: "Afrika",
    asia: "Asien",
    oceania: "Ozeanien",
    birthdate: "GEBURTSJAHR",
    birthdateQuestion: "Bitte gib Dein Geburtsjahr an",
  },
  gender: {
    caption: "Geschlecht",
    female: "weiblich",
    male: "männlich",
    diverse: "divers",
  },
  mode: {
    caption: "Modus",
    barefoot: "Barfuß",
    socks: "Socken",
    dark_socks: "dunkel Socken",
    bright_socks: "hell Socken",
  },
  auth: {
    login: "Anmelden",
    register: "Registrieren",
    confirm: "Bestätigen",
    connect: "Verbinden",
    createAccount: "Konto erstellen",
    logIn: "Anmelden",
    logOut: "Abmelden",
    addEmail: "E-Mail hinzufügen",
    changeEmail: "E-Mail ändern",
    stayConnected: "verbunden bleiben",
    logoutMessage: "Dieser Benutzer is angemeldet\nAbmelden?",
    passwordPlaceholder: "Bitte gib Dein Paswort ein",
    emailPlaceholder: "Bitte gib Deine Email ein",
    employeenumberPlaceholder: "Geben Sie die Nummer Ihres Mitarbeiters einr",
    emailRequired: "Email Adresse ist erforderlich.",
    emailInvalid: "Email Adress ist ungültig.",
    passwordRequired: "Passwort ist erforderlic.",
    firstNameRequired: "Vorname ist erforderlich.",
    lastNameRequired: "Nachname ist erforderlich.",
    dateOfBirthRequired: "Geburtsdatum ist erforderlich.",
    employeeNumberRequired: "Mitarbeiter-Nummer ist erforderlich.",
    unableToLogin: "Mit den angegebenen Daten ist das Anmelden nicht möglich",
    emailExists: "Einen Benutzer mit dieser Emial Adresse gibt es schon.",
    employeeNumberExists: "Es existiert ein Benutzer mit der gleichen Mitarbeiternummer.",
    unique: "Einen Benutzer mit dieser Emial Adresse gibt es schon.",
    confirmEmailAddedMessage: "Ihre E-Mail wurde hinzugefügt",
    addEmailInfo: "Fügen Sie Ihre E-Mail-Adresse hinzu, um auf Ihre Daten auf allen unterstützten Plattformen zuzugreifen",
    emailAddedInstructions: "Sie werden in Kürze eine E-Mail erhalten, um ein Passwort festzulegen.",
    provideAllFields: "Bitte füllen Sie alle Felder aus",
    genericError: "Es ist ein Fehler aufgetreten, bitte versuchen Sie es in einigen Augenblicken erneut.",
    succesRegisterMessage: ["Wir haben Deine\nOne", "Fitting ID", "erfolgreich gespeichert"],
    shoepassionSuccesRegisterMessage: ["Wir haben Deine ", "ShoepassionID", "erfolgreich gespeichert"],
    confirmRegisterMessage: ["Deine", "One Fitting ID", "wurde erfolgreich gespeichert! Klick auf den Link den wir Dir gesendet haben,", "um sie überall zu verwenden"],
    shoepassionConfirmRegisterMessage: ["Deine", "ShoepassionID", "wurde erfolgreich gespeichert! Klick auf den Link den wir Dir gesendet haben,", "um sie überall zu verwenden"],
    termsAndConditions: ["Ich habe die Datenschutzbestimmungen gelesen und stimme der Nutzung meiner Daten zu", "Datenschutzbestimmungen"],
    oneFittingIDCreation: "One Fitting ID erstellen",
    shoepassionNewsletter: ["Für Shoepassion Newsletter anmelden und Datennutzung laut", "zustimmen"],
  },
  support: {
    caption: "Einstellungen",
    selectScanner: "Scanner auswählen",
    calibration: "Kalibrierung",
    form: {
      textPlaceholder: "Beschreibe das Problem",
      namePlaceholder: "Name",
      sendButtonText: "Senden",
    },
    bottomCards: {
      customerSupport: {
        caption: "Kunden Support",
        phoneNumber: "OneFID: + 49 221 95793412",
        emailAddress: "scanner-support@onefid.com",
      },
      scannerId: {
        caption: "Scanner ID",
      },
    },
  },
  scan: {
    captionLeft: "BITTE STELLE DEINEN LINKEN FUẞ AUF SCANNER",
    succescaptionLeft: "LINKER FUẞ GESCANNT",
    captionRight: "BITTE STELLE DEINEN RECHTEN FUẞ AUF SCANNER",
    captionRightBirkenstock1: "Wir erstellen Deinen\nBIRKENSTOCK Scan",
    captionRightBirkenstock2: "Sie können den Scanner verlassen.\nDeine Scandaten werden in wenigen Sekunden fertig sein!",
    secondarySizeRecommendationBirkenstock: "Ihre Maße liegen zwischen zwei Größen, vielleicht möchten Sie auch eine",
    succescaptionRight: "RECHTER FUẞ GESCANNT",
    captionMulti: "BITTE STELLE DICH AUF DEN SCANNER",
    succescaptionMulti: "BEIDE FÜSSE GESCANNT",
    start: "START",
    left: "LINKER FUẞ",
    right: "RECHTER FUẞ",
    both: "BEIDE FÜSSE",
    inProgress: "DEINE FÜẞE WERDEN GESCANNT",
    setParameter: "KAMERA WIRD VORBEREITET",
    capture: "FÜSSE WERDEN GESCANNT",
    process: "3D SCAN WIRD VERARBEITET",
    keepStill: "Bitte stellen Sie sich ruhig",
    instructions: "Anweisungen",
    rollUpLegwear: "Krempeln Sie Ihre Kleidung hoch, so dass nichts im Scanner ist",
    positionFeet: "Platzieren Sie Ihren Fuß vor die Linie",
    distributeWeight: "Verteilen Sie Ihr Gewicht gleichmäßig auf beide Füße und stehen Sie ruhig",
    succesScanMessage: ["SCAN ERFOLGREICH", "Wir erstellen Deinen", "One", "FID", "BIRKENSTOCK", "Scan", "Dein Scan wird in wenigen Sekunden fertig sein!"],
    faildScanMessage: [
      "SCAN FEHLGESCHLAGEN",
      "Es gab ein problem mit Deinem One",
      "FID",
      "Scan.",
      "Bitte versuche es erneut.\nBitte kontaktiere den Kunden Support wenn das Problem weiter besteht.",
      "NOCHMAL SCANNEN",
      "ABBRECHEN",
    ],
    error: {
      title: "Da hat leider etwas nicht funktioniert.",
      callSupport: "Sollte das das Problem nicht beheben, bitte an den Support wenden.",
      genericError: "Es ist ein Fehler aufgetreten.",
      scannerBusy: "Scanner ist beschäftigt, bitte scannen Sie in einigen Sekunden erneut.",
      foamBoxNotImplemented: "Es ist ein Fehler aufgetreten.",
      log_output_too_short: "Es ist ein Fehler aufgetreten.",
      an_error_occured: "Es ist ein Fehler aufgetreten.",
      make_missing_target: "Bitte an den Support wenden.",
      incompatible_configuration_file: "Bitte an den Support wenden.",
      light_hardware_not_accessible: "Bitte den Scanner ausschalten und nach zehn Sekunden wieder einschalten. Dann die Messung wiederholen.",
      camera_initialization_fails: "Es ist ein Sensor-Fehler aufgetreten. Bitte den Reset des Scanners abwarten und dann die Messung wiederholen.",
      camera_provides_no_frames: "Es ist ein Sensor-Fehler aufgetreten. Bitte den Reset des Scanners abwarten und dann die Messung wiederholen.",
      meshlab_subdivision_surface_fails: "Bitte den Scanner verlassen, die Glasplatte reinigen, Hosenbeine evtl. erneut hochkrempeln, den Scanner wieder betreten und die Messung wiederholen.",
      meshlab_error: "Bitte den Scanner verlassen, die Glasplatte reinigen, Hosenbeine evtl. erneut hochkrempeln, den Scanner wieder betreten und die Messung wiederholen.",
      foot_length_unexpected: "Bitte den Scanner verlassen, die Glasplatte reinigen, Hosenbeine evtl. erneut hochkrempeln, den Scanner wieder betreten und die Messung wiederholen.",
      foot_width_unexpected: "Bitte den Scanner verlassen, die Glasplatte reinigen, den Scanner wieder betreten und die Messung wiederholen.",
      glass_plate_covered: "Bitte die Glasplatte freimachen.",
      foot_touches_bounding_volume: "Bitte die Füße entsprechend der Markierung positionieren.",
    },
  },
  insole: {
    caption: "Einlage",
    marketingText:
      "Auf Grundlage der Fuß-Analyse empfehlen wir eine zusätzliche Unterstützung durch eine Einlage.\nSo werden Ermüdung und Überlastungen vermieden. Basierend auf Ihrem 3D Scan erstellen wir eine Einlage mit passender Längsgewölbehöhe individueller Pelotte zur Unterstützung des Vorderfußes.",
    q1caption: "Haben Sie Schmerzen in den Füßen?",
    q2caption: "Tragen Sie orthopädische Einlagen oder sind Sie aufgrund von Fußproblemen in orthopädischer Behandlung?",
    q3caption: "Ergebnis",
    insoleTypeRequired: "Typ der Einlegesohle ist erforderlich",
    sizeRequired: "Größe ist erforderlich!",
    recommendation: {
      button: "KATALOG",
      0: {
        mainMessage: `Sie benötigen keine Einlage`,
        subMessage: "Auf Grundlage Ihrer Fuß-Analyse haben wir festgestellt, dass Sie keine auffällige Fußfehlstellung haben.",
        conclusion: "KEINE EINLAGE EMPFOHLEN",
      },
      1: {
        mainMessage: "Bitte lassen Sie sich orthopädisch beraten",
        subMessage: "Auf Grundlage Ihrer Fuß-Analyse empfehlen wir Ihnen eine ausführliche Begutachtung durch Ihren Orthopäden oder einen Orthopädie-Schuhmacher!",
        conclusion: "INDIVIDUELLE EINLAGE ERFORDERLICH",
      },
    },
  },
  MeasurementScale: {
    foot_type: "Fußtyp",
    heel_angle: "Fersenwinkel",
    arch_height: "Gewölbehöhe",
    foot_width: "Fußbreite",
    flat: "Flach",
    normal: "Normal",
    high: "Hoch",
    low: "Flach",
    pronation: "Pronation",
    neutral: "Neutral",
    supination: "Supination",
    narrow: "Schmal",
    wide: "Breit",
    millimeters: "Millimeter",
    cm: "Zentimeter",
    length: "Länge",
    width: "Breite",
    left: "Links",
    right: "Rechts",
    heightInstepPoint: "Höhe Spann",
    widthHeel: "Breite Ferse",
  },
  Order: {
    confirmMessage: "Soll der ausgewählte Schuh bestellt werden",
    successMessage: "Die Bestellung wurde erfolgreich übermittelt!",
    failureMessage: "Leider konnte die Bestellung nicht verarbeitet werden.",
    cotaFailureMessage: "Sie haben Ihr Bestellimit erreicht, Sie können diesen Schuh nicht bestellen.",
    success: "Vielen Dank",
  },
  CustomiseProduct: {
    confirmCustomisation: "Möchten Sie diese Schuhe individualisieren?",
    weight: {
      upto65Kg: "bis 65 Kg",
      from110Kg: "ab 110 Kg",
    },
    activity: {
      mostlyStanding: "Überwiegend Stehend",
      mostlyWalking: "Überwiegend Gehend",
      mostlySitting: "Überwiegend Sitzend",
    },
  },
  SafetyCatalog: {
    title: "Sicherheits Katalog",
    "work shoe": "Arbeitsschuhe",
    "work boot": "Arbeitsstiefel",
    "work sandal": "Arbeitssandalen",
  },
  RunningCtalog: {
    title: "Lauschuh Katalog",
    runningExperience: "ERFAHRUNG",
    runningExperienceQuestion: "Wie ist Deine Lauferfahrung?",
    occasionally: "Gelegentlich (1-2x)",
    regularly: "Regelmäßig (2-3x)",
    ambitious: "Ambitioniert (>3x)",
    application: "EINSATZ",
    applicationQuestion: "Für welche Anwendung suchst Du Schuhe?",
    walking: "Walking",
    competition: "Wettkampf",
    training: "Training",
    terrain: "TERRAIN",
    terrainQuestion: "Auf welchem Undergrund möchtest Du laufen?",
    trail: "Trail/Offraod",
    road: "Straße / Laufband",
    track: "Laufbahn",
    knee: "KNIEACHSE",
    kneeQuestion: "Wie ist Deine Knieachse ausgerichtet?",
    concave: "X-Bein (Valgus)",
    neutral: "Neutral",
    convex: "O-Bein (Varus)",
    heel: "FERSENWINKEL",
    heelQuestion: "Wie verhält sich Deine Ferse im Lauf?",
    pronation: "Innen (Pronation)",
    neutralheel: "Neutral",
    supination: "Außen (Supination)",
    cushioning: "DÄMPFUNG",
    cushioningQuestion: "In welcher Altersgruppe bist du?",
    soft: "Weich",
    hard: "HART / Direkt",
    natural: "Natural Running",
    normal: "Normal",
    ageGroup: "ALTERSGRUPPE",
    ageGroupQuestion: "Welche Altersgruppe?",
    kids: "KINDER",
    adults: "ERWACHSENE",
    noProducts: "Keine Produkte",
    filterCriteriaMessage: "Bitte ändere deine Suchkriterien oder ändere deine Auswahl im Filter.",
    resetFilter: "Filter zurücksetzen",
  },
  SkiCatalog: {
    title: "Ski Catalog",
    skill: "ERFAHRUNG",
    skillQuestion: "Wie erfahren bist Du?",
    beginner: "Anfänger",
    intermediate: "Fortgeschritten",
    expert: "Experte",
    race: "Wettkampf",
    terrain: "TERRAIN",
    terrainQuestion: "Wo willst Du fahren?",
    allmontain: "All Mountain",
    piste: "Piste",
    freeride: "Free Ride",
    hard: "Harte Piste",
    weight: "Gewicht",
    weightQuestion: "Wie schwer bist Du?",
    upto60: "bis 60 kg",
    "60to80": "60 bis 80 kg",
    "80to100": "80 bis 100 kg",
    morethan100: "mehr als 100 kg",
    ageGroup: "Altersgruppe",
    ageGroupQuestion: "Wie alt bist Du?",
    kids: "Kids",
    adults: "Erwachsen",
    noProducts: "Keine Produkte",
    filterCriteriaMessage: "Bitte ändere deine Suchkriterien oder ändere deine Auswahl im Filter.",
    resetFilter: "Filter zurücksetzen",
  },
  FilterCatalog: {
    title: "Filter Optionen",
    category: " Kategorie",
    brand: "Brand",
    color: "Farbe",
    leahtherType: "Leder Typ",
    underground: "Terrain",
    support: "Stütze",
    sale: "Sale",
    showProducts: "Zeige Produkte",
  },
  secondaryRecommendatiom: {
    yourSize: "DEINE GRÖßE",
    message1: "Deine Fußlänge ist zwischen zwei Größen, die Dir beide passen!",
    message2: "Wenn Du Deine Schuhe eher eng trägst, wähle: ",
    message3: "Wenn Du Deine Schuhe eher locker trägst, wähle: ",
  },
  expiviConfigurator: "Schuh Konfigurator",
  advertisingOnefid: "OneFID - Füße scannen und Schuhe finden die passen",
  consents: {
    title: "FUSS-SCANS - ZUSTIMMUNG",
    agreeText: "Ich stimme der beschriebenen Verarbeitung meiner Daten zu.",
    germanyConsent1: [
      "Durch die Nutzung des Fußscanners erklären Sie sich damit einverstanden, dass die BIRKENSTOCK Product GmbH die im Rahmen des Fußscan-Prozesses erhobenen Scandaten für die von Ihnen nachfolgend ausgewählten Zwecke verwendet. Ihre Einwilligung ist stets freiwillig und kann jederzeit per E-Mail an ",
      "privacy@birkenstock.com",
      ", unter Nennung Ihrer Scan-ID, die Sie mit heutigem Scan von uns erhalten, mit Wirkung für die Zukunft widerrufen werden.",
    ],
    germanyConsent2: ["Weitere Details finden Sie in der ", "Datenschutzerklärung."],
    germanyConsent3: [
      "Scandaten",
      "Ich bin einverstanden, dass meine Scandaten (z.B. Fußmessdaten und 3D-Modell, Alter, Geschlecht, Region, Zeitstempel, Scan-ID) verarbeitet werden, um mir eine Größenempfehlung für BIRKENSTOCK-Produkte zu geben und, dass die Daten pseudonymisiert für die Forschung und Entwicklung von BIRKENSTOCK-Produkten (z.B. Fußbetten) verwendet und die Scandaten hierfür mit anderen BIRKENSTOCK-Gesellschaften (insbesondere der Birkenstock Group B.V. & Co. KG) und Forschungsgesellschaften (z.B. Universitäten) geteilt werden können.",
      "Wir speichern Ihre Scandaten nicht unter einem Namen, sondern nur pseudonymisiert unter einer Kennung. Wenn Sie Ihre Scandaten löschen möchten, teilen Sie uns dies bitte ausdrücklich unter Nennung Ihrer Scan-ID mit, die Sie am Tag des Scans erhalten haben.",
    ],
    germanyConsent4: [
      "Verknüpfung des Scanergebnisses mit Ihrem Kundenkonto",
      "Wir bieten Ihnen die Möglichkeit, Ihr Scanergebnis mit Ihrem BIRKENSTOCK-Kundenkonto zu verknüpfen. Durch die Verknüpfung des Scanergebnisses mit Ihrem BIRKENSTOCK-Kundenkonto erklären Sie sich damit einverstanden, dass die BIRKENSTOCK Europe GmbH Ihre im Rahmen des Scan-Prozesses erhobenen Personenbezogenen Daten (z.B. Fußmessdaten und 3D-Modell, Alter, Geschlecht, Region, Zeitstempel, Scan-ID) hierfür verwendet.",
      "Ich bin damit einverstanden, dass meine Scandaten mit meinem BIRKENSTOCK-Konto verknüpft werden. Details zur Verarbeitung Ihrer personenbezogenen Daten im Rahmen des Birkenstock-Accounts finden Sie in unserer ",
    ],
  },
  privacyPolicy: {
    title: "Datenschutzhinweis - Fußscans",

    intro: "Diese Datenschutzerklärung enthält Informationen für alle Teilnehmenden darüber, wie wir Daten für unsere Fußscans verwenden. Bei Fragen wenden Sie sich bitte jederzeit an privacy@birkenstock.com.",

    sections: {
      what: {
        title: "1- WAS?",
        body: "Wenn wir Ihre Füße scannen, verarbeiten wir die folgenden Informationen:",
        list: [
          "Alter;",
          "Geschlecht;",
          "Region;",
          "Fußmessdaten und 3D-Modell (Messungen und Bilder);",
          "Datum und Uhrzeit des Scans;",
          "Scan-ID;",
          "E-Mail-Adresse (optional)."
        ],
        footer: "Die Daten werden pseudonymisiert unter einer kryptischen ID in unserem System gespeichert.\nEs wird kein Bild Ihres Fußes aufgenommen. Anatomische Veränderungen sind erkennbar, werden jedoch ohne persönlichen Bezug gespeichert. Papillarlinien, Narben und Tätowierungen sind auf dem Scan nicht sichtbar."
      },

      why: {
        title: "2- WARUM?",
        body: "Wir verwenden diesen Fußscanner, um Ihnen eine präzise Größenempfehlung für unser Schuhwerk zu geben. Darüber hinaus verwenden wir die pseudonymisierten Scandaten für die Forschung und Entwicklung von BIRKENSTOCK-Produkten (z.B. Fußbetten). Falls von Ihnen gewünscht, verwenden wir Ihre Daten auch dafür, um Ihre Messergebnisse mit Ihrem Birkenstock-Konto zu verknüpfen."
      },

      who: {
        title: "3- WER?",
        body: "Wir sind für die Verarbeitung Ihrer Daten gemeinsam verantwortlich. Wir haben einen Vertrag geschlossen, der unsere Verantwortlichkeiten als gemeinsame Verantwortliche regelt. Wenn wir von „wir” oder „BIRKENSTOCK” sprechen, meinen wir die folgenden Unternehmen:",

        company1: {
          name: "Birkenstock Product GmbH",
          address: ["Burg Ockenfels", "53545 Linz am Rhein", "Deutschland"],
          responsibility:
            "Zuständig für Ihre Anfragen zum Datenschutz (siehe unten Ziffer (6)) und um Ihnen Informationen zur Verarbeitung Ihrer Daten bereitzustellen. Sie können sich selbstverständlich auch stets an das andere verantwortliche Unternehmen wenden.",
        },
        company2: {
          name: "Birkenstock Europe GmbH",
          address: ["Burg Ockenfels", "53545 Linz am Rhein", "Deutschland"],
          responsibility: "",
        },

        dpo: {
          title: "Unseren Datenschutzbeauftragten erreichen Sie unter folgender Adresse:",
          name: "Birkenstock Product GmbH",
         address: ["Burg Ockenfels", "53545 Linz am Rhein", "Germany"],
          email: "dpo@birkenstock.com"
        },

        processors: [
          "Als Teil der BIRKENSTOCK-Gruppe können andere Unternehmen der BIRKENSTOCK-Gruppe uns bei der Verarbeitung Ihrer Daten unterstützen, insbesondere Birkenstock Group B.V. & Co. KG durch die Unterstützung des Betriebs und der Wartung unserer IT-Systeme sowie der Unterstützung in rechtlichen Fragen.",
          "Wenn Sie Ihre Scandaten mit Ihrem BIRKENSTOCK-Kundenkonto verknüpfen, werden diese mit anderen BIRKENSTOCK-Gesellschaften geteilt, insbesondere mit der Birkenstock Europe GmbH, als Betreiberin des Online-Shop Angebots, zu dem auch Ihr Kundenkonto gehört. Details zu den diesbezüglichen Datenverarbeitungen finden Sie unter:"
        ],

        processorsLinkText: "Privacy Policy | BIRKENSTOCK",
        processorsLinkURL: "https://www.birkenstock.com/de-en/privacy-policy/legal-privacy.html",

        provider: "Wir nutzen die Dienste der OneFID GmbH, Matthias-Brüggen-Str. 4, 50827 Köln, Deutschland, um die Informationen zu scannen, zu analysieren und zu speichern.",

        transfer: {
          intro: "Einige unserer Dienstleister und Konzernunternehmen, die möglicherweise Informationen von Ihnen von uns erhalten, haben ihren Sitz außerhalb der Europäischen Union (EU). Diese Länder verfügen möglicherweise nicht über ein mit der DSGVO vergleichbares Datenschutzniveau. Befindet sich ein Empfänger Ihrer Daten außerhalb der EU, gibt es grundsätzlich zwei Möglichkeiten, um sicherzustellen, dass auch außerhalb der EU ein angemessenes Schutzniveau für Ihre Daten gewährleistet ist:",
          list: [
            "Befindet sich ein Empfänger in einem Land, für das die Europäische Kommission ein angemessenes Datenschutzniveau festgestellt hat, stützen wir uns auf diese Angemessenheitsentscheidung der EU-Kommission. Die EU-Kommission bietet eine Übersicht über die Länder, für die Angemessenheitsentscheidungen getroffen wurden, die Sie  hier ",
            "Befindet sich ein Empfänger nicht in einem Land, für das die EU-Kommission ein angemessenes Datenschutzniveau festgestellt hat, schließen wir entweder einen Vertrag mit diesem Empfänger ab, in dem wir Regeln vereinbaren, um sicherzustellen, dass der Empfänger Ihre personenbezogenen Daten angemessen schützt (von der EU-Kommission entwickelte EU-Standardvertragsklauseln), oder wir stützen uns auf verbindliche Unternehmensregeln einer Unternehmensgruppe oder eines Unternehmens, die von einer Aufsichtsbehörde genehmigt wurden. Weitere Informationen erhalten Sie, indem Sie uns unter den in Abschnitt „(3)“ dieser Datenschutzerklärung angegebenen Kontaktdaten kontaktieren."
          ],
          linkText: "einsehen können",
          link: "https://commission.europa.eu/law/law-topic/data-protection/international-dimension-data-protection/adequacy-decisions_en?prefLang=de&etrans=de",
          outro: "Weitere Informationen erhalten Sie, indem Sie uns unter den in Abschnitt „(3)“ dieser Datenschutzerklärung angegebenen Kontaktdaten kontaktieren."
        }
      },

      legal: {
        title: "4- AUF WELCHER GRUNDLAGE?",
        body: "Die Rechtsgrundlage für die Verarbeitung Ihrer Daten ist Ihre Einwilligung gemäß Art. 6 Abs. 1 lit. a) Datenschutz-Grundverordnung („DSGVO“)."
      },

      retention: {
        title: "5- WIE LANGE?",
        body: "Die Daten werden gespeichert, bis Sie Ihre Einwilligung widerrufen oder die Daten für den erforderlichen Zweck nicht mehr benötigt werden."
      },

      rights: {
        title: "6- IHRE RECHTE",
        subtitle: "Wenn wir Ihre Daten verarbeiten, haben Sie gemäß der DSGVO folgende Rechte:",
        list: [
          "Recht auf Auskunft",
          "Auskunftsrecht",
          "Recht auf Berichtigung",
          "Recht auf Löschung („Recht auf Vergessenwerden“)",
          "Recht auf Einschränkung:",
          "Recht auf Datenübertragbarkeit",
          "Beschwerderecht",
          "Widerrufsrecht",
          "Widerspruchsrecht gegen automatisierte Entscheidungen einschließlich Profiling (Art. 22 Abs. 1 DSGVO).",
          "Widerspruchsrecht"
        ],
        explanations: [
          "Sie haben das Recht, Auskunft über die Verarbeitung Ihrer personenbezogenen Daten durch uns zu erhalten (Art. 13 und 14 DSGVO).",
          "Sie haben das Recht, eine Bestätigung darüber zu erhalten, ob wir Ihre personenbezogenen Daten verarbeiten, und, falls dies der Fall ist, Zugang zu den personenbezogenen Daten zu erhalten (Art. 15 DSGVO).",
          "Sie haben das Recht, die Berichtigung unrichtiger oder unvollständiger personenbezogener Daten zu verlangen (Art. 16 DSGVO).",
          "Unter bestimmten Umständen haben Sie das Recht, die Löschung der Sie betreffenden personenbezogenen Daten zu verlangen (Art. 17 DSGVO).",
          "Unter bestimmten Umständen haben Sie das Recht, die Einschränkung der Verarbeitung zu verlangen (Art. 18 DSGVO).",
          "Unter bestimmten Voraussetzungen haben Sie das Recht, die Sie betreffenden personenbezogenen Daten, die Sie uns bereitgestellt haben, in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten, und das Recht, diese Daten einem anderen Verantwortlichen zu übermitteln oder uns übermitteln zu lassen (Art. 20 DSGVO).",
          "Sie haben das Recht, sich bei einer Aufsichtsbehörde, insbesondere in dem EU-Mitgliedstaat Ihres gewöhnlichen Aufenthaltsorts, Ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes zu beschweren, wenn Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden personenbezogenen Daten gegen die DSGVO verstößt (Art. 77 DSGVO).",
          "Wenn die Verarbeitung Ihrer personenbezogenen Daten auf Ihrer Einwilligung beruht (Art. 6 Abs. 1 S. 1 lit. a) DSGVO oder Art. 9 Abs. 2 lit. a) DSGVO), haben Sie das Recht, Ihre Einwilligung jederzeit zu widerrufen (Art. 7 Abs. 3 DSGVO). Der Widerruf hat keinen Einfluss auf die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung.",
          "Sie haben das Recht, sich einer Entscheidung zu widersetzen, die ausschließlich auf einer automatisierten Verarbeitung - einschließlich Profiling - beruht und Ihnen gegenüber rechtliche Wirkung entfaltet oder Sie in ähnlicher Weise erheblich beeinträchtigt (Art. 22 Abs. 1 DSGVO).",
          "Unter bestimmten Umständen haben Sie das Recht, der Verarbeitung Ihrer personenbezogenen Daten zu widersprechen (Art. 21 DSGVO). Dieses Widerspruchsrecht besteht insbesondere in Fällen, in denen wir Ihre personenbezogenen Daten auf der Rechtsgrundlage von Art. 6 Abs. 1 S. 1 lit. f) DSGVO verarbeit",
        ],
        footer: "Wir verwenden keine automatisierte Datenverarbeitung (Art. 22 DSGVO), um Entscheidungen über Sie zu treffen - einschließlich Profiling -, die Ihnen gegenüber rechtliche Wirkung entfalten oder Sie in ähnlicher Weise erheblich beeinträchtigen.\nZur Ausübung Ihrer Betroffenenrechte teilen Sie uns bitte Ihre Scan-ID mit, die Sie am Tag des Scans von uns erhalten haben."
      }
    },

    meta: {
      date: "Date: 1/29/2026",
      version: "Version: 2.8",
    }
  },
};
